import { BODY_FONT_PT, FONT_SIZES } from '@root/helpers/editor';
import { isNonNullish } from '@root/helpers/isNonNullish';
import { clamp, minBy, sortedUniq } from 'lodash-es';

import { draftParagraphsOf, mapDraftParagraphs } from '../draft/blocks';
import type { ClauseDraft, DraftRun } from '../draft/types';

const LADDER: number[] = FONT_SIZES.map(({ pt }) => pt);
const BODY_INDEX = LADDER.indexOf(BODY_FONT_PT);

const nearestOnLadder = (sizePt: number) => minBy(LADDER, (pt) => Math.abs(pt - sizePt))!;

export const snapFontSizes = (draft: ClauseDraft): ClauseDraft => {
  const { bodySizePt } = draft;
  const sizes = sortedUniq(
    draftParagraphsOf(draft.blocks)
      .flatMap(({ runs }) => runs.map(({ format }) => format.sizePt))
      .filter(isNonNullish)
      .sort((a, b) => a - b),
  );
  const editorSizeOf =
    bodySizePt === undefined
      ? nearestOnLadder
      : (sizePt: number) =>
          LADDER[clamp(BODY_INDEX + sizes.indexOf(sizePt) - sizes.indexOf(bodySizePt), 0, LADDER.length - 1)];

  const snap = (run: DraftRun): DraftRun =>
    run.format.sizePt === undefined
      ? run
      : { ...run, format: { ...run.format, editorSizePt: editorSizeOf(run.format.sizePt) } };

  return { ...draft, blocks: mapDraftParagraphs(draft.blocks, (block) => ({ ...block, runs: block.runs.map(snap) })) };
};
